
















































































// @ is an alias to /src
import { Component, Vue, Watch } from 'vue-property-decorator'
import {AloArbo, getDefaultAloArbo} from '@/models/alo/AloArbo'
import CartDetail from '@/components/panier/CartDetail.vue'
import EditPlat from '@/components/carte/EditPlat.vue'
import { groupByNumber } from '@/utils/groupBy'
import { ItemPanier } from '@/models/alo/ItemPanier'
import DeliveryPicker from '@/components/shared/DeliveryPicker.vue'
import { AloCommande, getDefaultAloCommande } from '@/models/alo/AloCommande'
import { StatusCommande } from '@/enum/StatusCommande'
import { AloSejour } from '@/models/alo/AloSejour'
import { AloPanier } from '@/models/alo/AloPanier'
import { TemplateMail } from '@/enum/TemplateMail'
import { VuetifyConfirmObject } from 'vuetify-confirm'

@Component({
  name: 'Cart',
  components:{
    CartDetail
  }
})
export default class Cart extends Vue {
  
  private showEdit = false
  showHoraire = false
  saving  = false;

  get isAuthenticated(){
    return this.$store.myGetters.isAuthenticated
  }
  
  get canOrder(){
    return this.$store.myGetters.canOrder
  }  

  get allContactsType(){
    const contactTypes = this.sejour.chambres.map(c => `#${c}`)
    if(this.sejour?.sjrTel) contactTypes.push(this.sejour.sjrTel)
    return contactTypes
  }

  get contacts(){
    return this.panier.allContacts?this.allContactsType:this.panier.contacts
  }
  set contacts(value){    
    this.$store.myActions.ROOM_SERVICES_UPD_CONTACT(value)    
  }

  get showCart(){
    return this.$store.myGetters.showCart
  }
  set showCart(newValue){
    this.$store.myActions.UI_SET_CART_VISIBLITY(newValue)
  }

  get panier() {
    return this.$store.myGetters.panier    
  }  

  get sejour() {
    return {...this.$store.myGetters.user?.currentSejour,user:this.$store.myGetters.user} as AloSejour
  }

  get nbItems(){
    return this.panier.nbItems
  }  

  mounted(){
     this.$store.myGetters.panier.updateTime(this.$store.myGetters.arbosDic)
  }

  @Watch("nbItems")
  onNbItemsChanged(newValue:number){
    if(newValue == 0) this.showCart = false
  }
   
  updateHeureLivraison(heure:string){
    this.$store.myActions.ROOM_SERVICES_UPD_HEURE_LIVRAISON(heure)
  }

  updateCommentaire(comment:string){
    this.$store.myActions.ROOM_SERVICES_UPD_COMMENTAIRE(comment)
  }

  updateNbCouverts(nb:number){
    this.$store.myActions.ROOM_SERVICES_UPD_NB_COUVERTS(nb)
  }

  updateItemCommentaire (payload:{uuid:string,commentaire:string}) {     
    this.$store.myActions.ROOM_SERVICES_UPD_ITEM_COMMENTAIRE(payload)        
  }

  udpateQty(payload:{uuid:string,qty:number}){        
    if(payload.qty == 0) {
      this.$confirm(this.$t('Cart.AlertRemoveItem').toString(),{title: this.$t('Global.ConfirmDelete'),buttonTrueText:this.$t('Global.Yes'),buttonFalseText:this.$t('Global.No')} as VuetifyConfirmObject).then( (response) => {
          if(response){
            this.$store.myActions.ROOM_SERVICES_UPD_ITEM_QTY(payload)
          }
        }
      )
    }
    else  {
      this.$store.myActions.ROOM_SERVICES_UPD_ITEM_QTY(payload)
    }
  }  

  udpateCartItem(item:ItemPanier){
    this.$store.myActions.ROOM_SERVICES_UPD_CART_ITEM(item)
  }

  sendOrder() {        
    if(this.panier.heureLivraison == "" || new Date(this.panier.heureLivraison?.replace("Z","")) <= (this.$refs.cartDetail as CartDetail).minDateCrenaux()) { 
      this.$confirm(this.$t('Cart.AlertDelevery').toString(),{title: this.$t('Cart.AlertDeleveryTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
    }
    else{
      if(this.panier.allContacts) this.$store.myActions.ROOM_SERVICES_UPD_CONTACT(this.allContactsType)    
      const commande:AloCommande = {
        ...getDefaultAloCommande(),
        panier:this.panier,     
        panStatus:StatusCommande.EnAttenteValidation,
        sejour:this.sejour,
        mtpId:TemplateMail.CommandeAjoutee,
        panLg:this.$i18n.locale,
        panUiid:this.panier.uuid
      }

      this.saving = true
      this.$store.myActions.ADM_COMMANDE_SAVE_REQUEST(commande).then((commande)=>{
        this.$store.myActions.ROOM_SERVICES_CLEAR_PANIER()    
        let messageValid = this.$t('Cart.AlertOrderSaved').toString()
        if(commande.panStatus == StatusCommande.EnAttenteValidation) messageValid = messageValid + `<br/>${this.$t('Cart.FinalizeOperator')}`
        this.$confirm(messageValid,{title: this.$t('Cart.AlertOrderSavedTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject).then(()=>{
          if(this.$route.name != "OrderHistory") {            
            this.$router.push({name:'DetailHistory',params:{commandeId:commande.id.toString()}})
          }
        })
      }).catch(e=>{
        this.$confirm(this.$t('Cart.AlertDelevery').toString(),{title: this.$t('Cart.AlertDeleveryTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
      }).finally(()=>{
        this.saving = false

      })
    }

  }

  clearCart(){
    this.$confirm(this.$t('Cart.AlertClear').toString(),{title: this.$t('Global.Warning'),buttonTrueText:this.$t('Global.Yes'),buttonFalseText:this.$t('Global.No')} as VuetifyConfirmObject).then( (response) => {
        if(response){
          this.$store.myActions.ROOM_SERVICES_CLEAR_PANIER()   
        }
      }
    )
  }

  createAccount(useUser = false) {
    this.showCart = false
    if(this.$route.name!='NewSejour') this.$router.push({name:'NewSejour',params:{useUser:useUser?"1":"0"}})    
  }

  goToLogin(){
    this.showCart = false
    if(this.$route.name!='Login') this.$router.push({name:'Login'})    
  }
}
